'use client'
import { axiosAdmin } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";



export function useGetCategoryResults(categoryIds: string, queryParams: Record<string, any> = {}) {
  return useQuery({
    queryKey: ["getcategory", categoryIds, queryParams],
    queryFn: async () => {

      try {
        if (categoryIds) {
          const response = await axiosAdmin.get(`/user/products/filter?categoryId=${categoryIds}`, {
            params: queryParams, // Other filters passed as query params
          })
          return response?.data
        }
        return null
      } catch (error) {
        throw error
      }
    },
    enabled: !!categoryIds, // Only run query if categoryIds exist
  })
}

export function useGetCategory(id: any = {}) {
  return useQuery({
    queryKey: ["getcategory", id],
    queryFn: async () => {
      try {
        if (id) {
          const response = await axiosAdmin.get(`/user/categories/${id}`)
          return response?.data
        }
        return null
      } catch (error) {
        throw error
      }
    },
  })
}

export function useGetAllCategories() {
  return useQuery({
    queryKey: ['getallcategories'],
    queryFn: async () => {
      try {
        const response = await axiosAdmin.get("/user/categories");
        return response?.data;
      } catch (error) {
        throw error;
      }
    }
  });
}